import "./TitleSimulator.css";
import { Col } from "react-bootstrap";

const TitleSimulator = () => {
  return (
    <Col
      style={{
        paddingBottom: " 1.9375rem",
      }}
      className=" mx-4 mx-md-0"
    >
      <p className="title__welcome__paragraph mb-0">
        Bem-vindo ao simulador de
      </p>
      <h1 className="title__welcome__h1">Financiamento imobiliário</h1>
    </Col>
  );
};

export default TitleSimulator;
